import React from "react";
import about1 from "../../../assets/icons/about1.png";
import about2 from "../../../assets/icons/about2.png";
import "./Ivory.css";
import { useTranslation } from "react-i18next";


const IvorySection = () => {
  const { t } = useTranslation();
  return (
    <section className="ivory-about">
      {/* Vision, Mission, Values Section */}
      <div className="container">
        <div className="row justify-content-between">
          <VisionCard
            icon={about1}
            title={t('about.title-1')}
            description={t('about.desc-1')}
          />
          <VisionCard
            icon={about2}
            title={t('about.title-2')}
            description={t('about.desc-2')}
          />
        </div>
      </div>
    </section>
  );
};

// Vision Card Component
const VisionCard = ({ icon, title, description }) => {
  return (
    <>
      <div className="vision-card">
        <img src={icon} alt={title} />

        <h6>{title}</h6>
        <span>{description}</span>
      </div>
    </>
  );
};

export default React.memo(IvorySection);